import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import Login from './Login'

import * as AuthService from 'services/auth.service'

import '_metronic/_assets/sass/pages/login/login-1.scss'

export default function AuthPage() {

  const [imageBase64, setImageBase64] = React.useState(null)

  React.useEffect(() => {
    AuthService.obtenerCompaniaLogo()
      .then(({ data }) => {
        setImageBase64(data || '')
      })
      .catch(({ data: { error } }) => console.log(error))
  }, [])

  return (
    <>
      <div id='login_main-container'>
        <div className='zr-sheet login-sheet'>
          <div className='login-title-container'>
            {imageBase64 !== null && imageBase64 !== '' && (
              <div style={{ width: '100%', textAlign: 'center', justifyContent: "center", marginBottom: "40px" }}>
                <img src={imageBase64} alt="Base64" style={{ maxWidth: '150px', maxHeight: '150px' }} />
              </div>
            )}
            <h1 className='login-title'>CONTASOFT</h1>
            <h3 className='login-subtitle'>I·N·V·E·N·T·A·R·I·O·S</h3>
          </div>
          <Switch>
            <Route path='/auth/login' component={Login} />
            <Redirect from='/auth' exact={true} to='/auth/login' />
            <Redirect to='/auth/login' />
          </Switch>
          <a href='a' className='login-recuperar-contrasena'>
            Recuperar contraseña
          </a>
        </div>
      </div>
    </>
  )
}
